module.exports = "https://health.dajiuxing.com.cn/img/assets/personalInformation/headbackground.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FpersonalInformation%2Fheadbackground.png
// module id = YlNn
// module chunks = 93